/* Small inline icons, drawn in currentColor so every state comes from CSS. */

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
};

export const GripIcon = () => (
  <svg width="14" height="18" viewBox="0 0 14 18" aria-hidden focusable={false}>
    {[4, 9, 14].map((y) => (
      <g key={y} fill="currentColor">
        <circle cx="4.5" cy={y} r="1.4" />
        <circle cx="9.5" cy={y} r="1.4" />
      </g>
    ))}
  </svg>
);

export const MinusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base}>
    <path d="M3 7h8" />
  </svg>
);

export const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base}>
    <path d="M7 3v8M3 7h8" />
  </svg>
);

export const SendIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...base} strokeWidth={2}>
    <path d="M8 13V3M3.5 7.5 8 3l4.5 4.5" />
  </svg>
);

export const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base} strokeWidth={2}>
    <path d="m3 7.5 2.5 2.5L11 4.5" />
  </svg>
);

export const SkipIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base}>
    <circle cx="7" cy="7" r="4.5" />
    <path d="M4 10 10 4" />
  </svg>
);

export const MoreFocusIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...base} strokeWidth={2}>
    <path d="M6 10V2.5M2.5 6 6 2.5 9.5 6" />
  </svg>
);

export const LessFocusIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...base} strokeWidth={2}>
    <path d="M6 2v7.5M2.5 6 6 9.5 9.5 6" />
  </svg>
);

export const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...base} strokeWidth={2}>
    <path d="m3 3 6 6M9 3 3 9" />
  </svg>
);

export const LockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base}>
    <rect x="3" y="6.5" width="8" height="5.5" rx="1.25" />
    <path d="M4.75 6.5V4.75a2.25 2.25 0 0 1 4.5 0V6.5" />
  </svg>
);

/** Move earlier and later in an order that reads top to bottom. */
export const EarlierIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...base} strokeWidth={2}>
    <path d="m2.75 7.25 3.25-3.5 3.25 3.5" />
  </svg>
);

export const LaterIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...base} strokeWidth={2}>
    <path d="m2.75 4.75 3.25 3.5 3.25-3.5" />
  </svg>
);

/** A small mark for a message that says something can't be done as asked. */
export const AlertIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" {...base}>
    <circle cx="7" cy="7" r="5.25" />
    <path d="M7 4.25v3.25M7 9.75h.01" />
  </svg>
);
